import dynamic from "next/dynamic";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import { colors } from "../../../utils/const";
import { useI18n } from "@/i18n/I18nProvider";

import PageHead from "@/components/PageHead";
import SmallTitle from "@/components/mini-components/SmallTitle";
import PartenerTypes from "@/components/Partner-types";
import BackGround from "@/components/partnership/BackGround";

const Form = dynamic(
  () => import("../../../components/form-medical-supplies/Form.jsx"),
  {
    loading: () => (
      <Box
        sx={{
          width: "100%",
          minHeight: { xs: 520, md: 600 },
        }}
      />
    ),
  }
);

const OurPartners = dynamic(() => import("@/components/OurPartners"), {
  loading: () => (
    <Box
      sx={{
        backgroundColor: "#F2F2F2",
        minHeight: { xs: 300, md: 420 },
      }}
    />
  ),
});

const PAGE_WRAPPER_SX = {
  position: "relative",
  backgroundColor: "#F2F2F2",
  overflow: "hidden",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: 0,
};

const HERO_TOP_SX = {
  bgcolor: "#282780",
  height: "250px",
  width: "100%",
  borderRadius: "0 0 87px 87px",
  position: "relative",
  zIndex: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const CARD_SX = {
  width: "1000px",
  maxWidth: "1000px",
  bgcolor: "#fff",
  position: "relative",
  top: "-100px",
  zIndex: 1,
  p: { xs: "20px", md: "40px" },
  borderRadius: "37px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
};

const PARTNER_TYPES_CONTAINER_SX = {
  borderRadius: "18px",
  background: "white",
  boxShadow: "rgba(4, 9, 33, 0.05) 0px 3px 0px",
  padding: { xs: "8px", sm: "10px", md: "24px", lg: "24px" },
  justifyContent: "center",
  alignItems: "center",
  gap: "32px",
  display: "flex",
  mb: "48px",
};

const TITLE_WRAPPER_SX = {
  position: "relative",
  display: "inline-block",
  pb: "25px",
};

const SUBTITLE_SX = {
  pb: "12px",
  fontSize: "20px",
  fontWeight: "bold",
  color: "#040921",
  m: 0,
  textAlign: "center",
};

const DESCRIPTION_SX = {
  pb: "50px",
  fontSize: "12px",
  fontWeight: 300,
  color: "#404456",
  textAlign: "center",
  maxWidth: "600px",
  m: 0,
};

const PARTNERS_SECTION_SX = {
  backgroundColor: "#F2F2F2",
};

export default function Index() {
  const { t, locale } = useI18n();

  const meta = t?.pages_main_tags?.partnership?.Medical;
  const isEnglish = locale === "en";

  return (
    <>
      <PageHead
        title={meta?.title}
        description={meta?.meta_desc}
      />

      <Box sx={PAGE_WRAPPER_SX} className="horizontal-safe-padding">
        <Box sx={HERO_TOP_SX}>
          <BackGround />
        </Box>

        <Box sx={CARD_SX}>
          <Box
            component="img"
            src="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/line-main.webp"
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
            sx={{
              width: "110%",
              height: "6px",
              position: "absolute",
              left: "-2px",
              bottom: 0,
              transform: isEnglish ? "scaleX(-1)" : "scaleX(1)",
              pointerEvents: "none",
            }}
          />

          <Container
            maxWidth={false}
            disableGutters
            sx={PARTNER_TYPES_CONTAINER_SX}
          >
            <PartenerTypes />
          </Container>

          <Box sx={TITLE_WRAPPER_SX}>
            <SmallTitle h1="h1" title={t.form_title2} />
          </Box>

          {/* <Box component="h2" sx={SUBTITLE_SX}>
            {t.form_sub2}
          </Box> */}

          <Typography component="p" sx={DESCRIPTION_SX}>
            {t.form_des2}
          </Typography>

          <Form color={colors.blue} />
        </Box>
      </Box>

      <Box component="section" sx={PARTNERS_SECTION_SX}>
        <OurPartners h3="h3" />
      </Box>
    </>
  );
}